var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilitNetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5726 35.6859C30.0183 35.6859 32.8116 32.8926 32.8116 29.4468C32.8116 26.0011 30.0183 23.2078 26.5726 23.2078C23.1268 23.2078 20.3335 26.0011 20.3335 29.4468C20.3335 32.8926 23.1268 35.6859 26.5726 35.6859Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2995 26.4365C40.6783 26.4365 36.9321 30.1827 36.9321 34.8039H53.6669C53.6669 30.1827 49.9206 26.4365 45.2995 26.4365Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7143 50.7922C28.5906 50.7922 22.7949 44.9966 22.7949 37.8728H29.4637C29.4637 41.3194 32.2677 44.1234 35.7143 44.1234C39.1609 44.1234 41.9649 41.3194 41.9649 37.8728H48.6336C48.6336 44.9966 42.838 50.7922 35.7143 50.7922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitNetLogo);
export default __webpack_public_path__ + "static/media/facilit-net-logo.0e824b517fcea8251a6f30f45ba819df.svg";
export { ForwardRef as ReactComponent };